import { FeatureIdTemplateMapping, FeatureTypes } from "entity-app/constants";
import { Tooltip } from "antd";
import { useMemo } from "react";
import FeatureHistoryItem from "./feature-history-item";

export default function FeatureHistory(props: {
  featureInstanceData: any;
  featureType: FeatureTypes;
}) {
  const { featureInstanceData, featureType } = props;

  const histories = useMemo(() => {
    if (!featureInstanceData?.feature_instance_histories) return [];

    if (featureType === FeatureTypes.SUBMITTALS) {
      const actionTypes = [1, 3, 6, 7];

      return featureInstanceData?.feature_instance_histories?.filter(
        (history: any) =>
          history?.feature_type_id === featureType &&
          (actionTypes.includes(history?.action_type) ||
            (history?.action_type === 2 &&
              history?.action_description?.includes("Deadline")))
      );
    }
    const filteredHistories =
      featureInstanceData?.feature_instance_histories?.filter(
        (history: any) => history?.feature_type_id === featureType
      );
    return filteredHistories;
  }, [featureInstanceData?.feature_instance_histories, featureType]);

  if (!histories?.length) {
    return (
      <div
        className="flex h-full items-center justify-center"
        data-testid="feature-history-empty"
      >
        <span
          className="text-xs text-neutral-400"
          data-testid="feature-history-empty-message"
        >
          No {`${FeatureIdTemplateMapping[featureType]}`.toLowerCase()} history
          is available.
        </span>
      </div>
    );
  }

  return (
    <div data-testid="feature-history-container">
      {histories?.map((history: any) => (
        <Tooltip
          key={history?.id}
          title={history?.comment ? `Comment: ${history?.comment}` : ""}
          placement="left"
          data-testid="feature-history-tooltip"
        >
          <div
            className="border border-solid border-black border-opacity-20 p-2 my-1 text-xs"
            data-testid="feature-history-item-wrapper"
          >
            <FeatureHistoryItem history={history} />
          </div>
        </Tooltip>
      ))}
    </div>
  );
}
